import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguageFromStorage } from 'syf-js-utilities';
import es from './lang/es';
import en from './lang/en';
const translations = {
    en,
    es
};
export { en, es };
const i18n = createInstance({
    fallbackLng: 'en', // use en if detected lng is not available
    lng: getLanguageFromStorage(),
    interpolation: {
        escapeValue: false // react already safe from xss
    },
    resources: translations,
    parseMissingKeyHandler: () => ''
});
export const translate = (key, options) => {
    if (options) {
        return i18n.t(key, options);
    }
    return i18n.t(key);
};
i18n.use(LanguageDetector).use(initReactI18next).init();
export default i18n;
